import { browserLocale } from './helper';
import { ICONS, IMAGES } from "../assets";

const langBrowser = browserLocale();

const Store = {

    //язык сайта
    lang: langBrowser === "ru" ? true : false,

    //модальное окно открыто/закрыто
    modalGallery: false,
    modalBlog: false,
    modalHotel: false,
    modalForm: false,
    modalMenu: false,

    //размер экрана
    screenwidth: window.screen.width,

    contentCurrentBlog: [],
    mail: "mailto:omelnik70@gmail.com",
    arrow: ICONS.ARROW,
    arrow_top: ICONS.ARROW_TOP,
    currentScroll: 0,
    top: null,
    about: null,
    gallery:  null,
    numbers:  null,
    contact: null,
    telegram: {
        link: "https://t.me/+X8E5ELkkYYEzM2Yy",
        img: ICONS.TELEGRAM,
    },
    slider: [
        {
            img: {
                img_1280: IMAGES.CAROUSEL.CAROUSEL_1_1280,
                img_768: IMAGES.CAROUSEL.CAROUSEL_1_768,
                img_300: IMAGES.CAROUSEL.CAROUSEL_1_300,
            },
        },
        {
            img: {
                img_1280: IMAGES.CAROUSEL.CAROUSEL_2_1280,
                img_768: IMAGES.CAROUSEL.CAROUSEL_2_768,
                img_300: IMAGES.CAROUSEL.CAROUSEL_2_300,
            },
        },
        {
            img: {
                img_1280: IMAGES.CAROUSEL.CAROUSEL_3_1280,
                img_768: IMAGES.CAROUSEL.CAROUSEL_3_768,
                img_300: IMAGES.CAROUSEL.CAROUSEL_3_300,
            },
        },
    ],

    ua: {
        //heder
        logoSite: `Микуличин`,
        subTitle: "Ласкаво просимо до Карпат!",
        description: "Чисте повітря, прекрасні гори, свіжозварене пиво чекають саме на Вас!",
        metaDescription: "Чисте повітря, чудові гори, свіжозварене пиво, піший туризм, походи по горах, лижний курорт, зимові розваги",
        metaKeywords: "Микуличин, відпочинок у горах, походи в гори, зимовий відпочинок, лижний курорт, карпатські чани",
        message: "Написати нам",
        hotelOpenList: "Відкрити список готелів",
        btn: {
            text: "Реклама на сайті",
            hotel: "Перейти на сайт",
            email: "Отправити повідомлення",
            phone:  "+380971644422",
            phoneLink: "tel:+380971644422",
            emailLink: "mailto:mikulichin@online.ua",
            img: ICONS.PHONE,
        },
        nav: {
            about: "Про нас",
            hotels: "Готелі",
            gallery: "Галерея",
            blog: "Блог",
            contact: "Контакти",
        },
        service: [
            {
                src: ICONS.LOCATION, 
                title: "Розташування", 
                text: "Микуличин знаходиться на висоті близько 750 метрів над рівнем моря. Село розташоване в долині річки Прут.",
            },
            {
                src: ICONS.FOOD, 
                title: "Магазини", 
                text: "У Микуличині є магазини з сувенірами, продуктами харчування, господарськими та іншими товарами корисними.",
            },
            {
                src: ICONS.SAUNA, 
                title: "Розваги", 
                text: "Піші прогулянки горами, свіжозварене пиво, ресторани, карпатські чани, старовинна церква, водоспад, тощо.",
            },
        ],
        gallery: [
            {
                src : {
                    src_1280: IMAGES.GALLERY.GALLERY_1_1280, 
                    src_768: IMAGES.GALLERY.GALLERY_1_768,
                    src_300: IMAGES.GALLERY.GALLERY_1_300,
                },
                title: "Кадиба для приготування їжі на відкритому вогні.",
            },
            {
                src : {
                    src_1280: IMAGES.GALLERY.GALLERY_2_1280, 
                    src_768: IMAGES.GALLERY.GALLERY_2_768,
                    src_300: IMAGES.GALLERY.GALLERY_2_300,
                },
                title: "Екстер'єр готелю з боку прилеглої території.",
            },
            {
                src : {
                    src_1280: IMAGES.GALLERY.GALLERY_3_1280, 
                    src_768: IMAGES.GALLERY.GALLERY_3_768,
                    src_300: IMAGES.GALLERY.GALLERY_3_300,
                },
                title: "Відпочинковий зал біля чана.",
            },
            {
                src : {
                    src_1280: IMAGES.GALLERY.GALLERY_4_1280, 
                    src_768: IMAGES.GALLERY.GALLERY_4_768,
                    src_300: IMAGES.GALLERY.GALLERY_4_300,
                },
                title: "Типовий інтер'єр одного із номерів класу 'Стандарт'.",
            },
        ],
        aboutTitle: "Микули́чин – гарантія гарного настрою!",
        aboutText: "Микули́чин — село в Івано-Франківській області, підпорядковане Яремчанській міськраді. Низькогірний кліматичний курорт, розташований у долині річки Прута. Окрасою Микуличина є пам'ятка архітектури — церква Святої Трійці (1868 р.) і дзвіниця, яка побудована значно раніше.",
        aboutImg: [
            {
                src: IMAGES.ABOUT.MYKULYCHYN, 
                title: "Прекрасний вид на Микуличин.",
            },
            {
                src: IMAGES.ABOUT.MYKULYCHYN_GERB, 
                title: "Герб Микуличина.",
            },
            {
                src: IMAGES.ABOUT.MYKULYCHYN_PRAPOR, 
                title: "Прапор Микуличина.",
            },
        ],
        review: [
            {
                title: "Казкові місця", 
                text: "Були в серпні, ходили в гори по гриби та ягоди. Сядеш на пеньок відпочити, руку простягнеш і ягода у твоїй руці.", 
                img: IMAGES.REVIEW.REVIEW_1, 
                auhtor: "Микола, Харків",
                rating: [1,2,3,4,5],
            },
            {
                title: "Зелені гори", 
                text: "Всі гори в окрузі пашать зеленню, повітря чистіше, йдеш і насолоджуєшся одночасно красою чистим повітрям.", 
                img: IMAGES.REVIEW.REVIEW_2, 
                auhtor: "Поліна, Київ",
                rating: [1,2,3,4,5],
            },
            {
                title: "Гірські річки", 
                text: "Вздовж траси Івано-Франківськ – Буковель протікає наскільки гірських річок, дуже красиво, влітку можна навіть охолоне.", 
                img: IMAGES.REVIEW.REVIEW_3, 
                auhtor: "Ярослав, Херсон",
                rating: [1,2,3,4,5],
            },
            {
                title: "Ідеальне місце", 
                text: "Відпочивали у приватному будинку у господарів, просто біля підніжжя гір. Перебували на весь рік, але наступного року приїдемо ще.", 
                img: IMAGES.REVIEW.REVIEW_4, 
                auhtor: "Ольга, Вінниця",
                rating: [1,2,3,4,5],
            },
            {
                title: "Ми в захваті", 
                text: "Ми у захваті, нам усе сподобалося. Дуже смачне місцеве пиво, рекомендую поціновувачам, та й чарівна природа навколо.", 
                img: IMAGES.REVIEW.REVIEW_5, 
                auhtor: "Світлана, Хмельницький",
                rating: [1,2,3,4,5],
            },
            {
                title: "Все подобається", 
                text: "Якщо набридло місто і Ви працюєте вдома, тут чудово підходить для віддаленої роботи, хороший інтернет та смачна їжа.", 
                img: IMAGES.REVIEW.REVIEW_6, 
                auhtor: "Вікторія, Кіровоград",
                rating: [1,2,3,4,5],
            },
            {
                title: "Приемлемые цены", 
                text: "Відпочивали взимку. Кататися їздили до Буковеля, але жили тут. Менше метушні та прийнятні ціни. Ще є де поставити машину.", 
                img: IMAGES.REVIEW.REVIEW_7, 
                auhtor: "Геннадий, Чернигов",
                rating: [1,2,3,4,5],
            },
            {
                title: "Сімейний відпочинок", 
                text: "Чудове місце для сімейного відпочинку. Недорого, красива природа, навколо багато магазинів, ресторан, піцерія, суші бар.", 
                img: IMAGES.REVIEW.REVIEW_8, 
                auhtor: "Ольга, Полтава",
                rating: [1,2,3,4,5],
            },
            {
                title: "Хочу повернутися", 
                text: "Дуже вдале розташування до локацій. Поблизу є гори, долина та річка. Розташовує до прогулянок. Хочеться повернутись.", 
                img: IMAGES.REVIEW.REVIEW_9, 
                auhtor: "Петро, Миколаїв",
                rating: [1,2,3,4,5],
            },
        ],
        
        hotelsTitle: "Реклама на сайті",
        hotels: [
            {
                title: "Назва готелю",
                img: IMAGES.HOTELS.HOTEL1,
                link: "https://www.google.com/",
                rating: [1,2,3,4,5],
                lable: [
                    {
                        new: "",
                    },
                    {
                        hot: "",
                    },
                    {
                        other: "Сніданок безкоштовно!",
                    },
                ],
                phone: "+0000000000000",
                description: "Короткий опис готелю - приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад.",
            },
            {
                title: "Назва готелю",
                img: IMAGES.HOTELS.HOTEL2,
                link: "https://www.google.com/",
                rating: [1,2,3,4],
                lable: [
                    {
                        new: "Новий готель",
                    },
                    {
                        hot: "",
                    },
                    {
                        other: "",
                    },
                ],
                phone: "+0000000000000",
                description: "Короткий опис готелю - приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад.",
            },
            {
                title: "Назва готелю",
                img: IMAGES.HOTELS.HOTEL3,
                link: "https://www.google.com/",
                rating: [1,2,3],
                lable: [
                    {
                        new: "",
                    },
                    {
                        hot: "Гаряча пропозиція!",
                    },
                    {
                        other: "",
                    },
                ],
                phone: "+0000000000000",
                description: "Короткий опис готелю - приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад.",
            },
            {
                title: "Назва готелю",
                img: IMAGES.HOTELS.HOTEL4,
                link: "https://www.google.com/",
                rating: [1,2,3,4],
                lable: [
                    {
                        new: "",
                    },
                    {
                        hot: "",
                    },
                    {
                        other: "Вид на гори",
                    },
                ],
                phone: "+0000000000000",
                description: "Короткий опис готелю - приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад, приклад.",
            },

        ],

        blog: [
            {
                title: "Природна краса Микуличина",
                img: {
                    img_1280: IMAGES.BLOG.WATERFALL_1280,
                    img_768: IMAGES.BLOG.WATERFALL_768,
                    img_300: IMAGES.BLOG.WATERFALL_300,
                },
                content: [
                    {
                        h2: "Водоспад Женецький Гук",
                        img: {
                            img_1280: IMAGES.BLOG.WATERFALL_1280,
                            img_768: IMAGES.BLOG.WATERFALL_768,
                            img_300: IMAGES.BLOG.WATERFALL_300,
                        },
                        p: "Один із найвищих карпатських водоспадів – його висота 15 м, а сам він знаходиться на висоті близько 900 м над рівнем моря. Від села Микуличин до водоспаду – 8 км, і щоб дістатися до нього, треба сісти на будь-який рейсовий автобус та вийти перед поворотом на Гук. Далі дорогу вкажуть покажчики. Перейшовши залізничні колії ви побачите контрольно-пропускний пункт, де потрібно буде сплатити прохід до водоспаду (з дорослої близько 10 грн, за дитину – дешевше, за проїзд автотранспорту стягується окрема плата). Далі асфальтовою дорогою доведеться йти 1-1,5 години, потім дорога зміниться на грунтовку. Весь маршрут промаркований, головне йти за вказівниками. Неподалік водоспаду розташувався сувенірний ринок, де можна купити карпатські трав'яні чаї, випити глінтвейн або гарячу каву, що особливо приємно в холодну пору. У водоспаду є альтанки та лавки, обладнані оглядові майданчики з драбинками та поручнями, поряд знаходиться невелике кафе-колиба. Місце користується популярністю у туристів у будь-яку пору року, тому їхати до водоспаду бажано раніше, щоб встигнути насолодитися природою в тиші.",
                    },
                    {
                        h2: "Гора Костел",
                        img: {
                            img_1280: IMAGES.BLOG.MOUNTAINCHURCH_1280,
                            img_768: IMAGES.BLOG.MOUNTAINCHURCH_768,
                            img_300: IMAGES.BLOG.MOUNTAINCHURCH_300,
                        },
                        p: "Розташована за 4,5 км на схід від Микуличина. Підйом можна розпочати від автомобільного мосту через річку Прутець Чемиговський. Вершину гори вінчає велика скеля з плоским верхом в оточенні дрібнішого каміння. На гору можна піднятися самостійно або замовити тур на позашляховику практично до вершини (такі екскурсії пропонують у готелях та садибах).",
                    },
                    {
                        h2: "Гора Ягідна",
                        img: {
                            img_1280: IMAGES.BLOG.BERRYMOUNTAIN_1280,
                            img_768: IMAGES.BLOG.BERRYMOUNTAIN_768,
                            img_300: IMAGES.BLOG.BERRYMOUNTAIN_300,
                        },
                        p: "Дорога, що веде до неї, починається прямо від автобусної зупинки. Підйом нескладний, без крутих ділянок. До вершини Ягідної йти години 2-3, але це того варте – з вершини відкривається шикарний краєвид на Чорногорський хребет. На вершині Ягідної є альтанка - можна відпочити, перекусити і вдосталь милуватися краєвидами, що відкриваються.",
                    },
                    {
                        h2: "Гора Маковиця.",
                        img: {
                            img_1280: IMAGES.BLOG.MOUNTAINMAKOVITSA_1280,
                            img_768: IMAGES.BLOG.MOUNTAINMAKOVITSA_768,
                            img_300: IMAGES.BLOG.MOUNTAINMAKOVITSA_300,
                        },
                        p: "То одна з найвищих гір Яремче. Шлях займе 1,5-2 години. Центральною вулицею треба буде пройти у бік вулиці Гірської і далі у бік Маковиці. На її вершині стоїть металевий хрест, а при сходженні можна побачити окопи та знайти гільзи – сліди минулих війн.",
                    },
                    {
                        h2: "Гори Хом'як та Синяк.",
                        img: {
                            img_1280: IMAGES.BLOG.MOUNTAINHAMSTER_1280,
                            img_768: IMAGES.BLOG.MOUNTAINHAMSTER_768,
                            img_300: IMAGES.BLOG.MOUNTAINHAMSTER_300,
                        },
                        p: "Похід подужать і новачки, і діти, тому що перепад висот невеликий, а на дорогах немає особливих перешкод. Один із маршрутів на м. Хом'як пролягає дорогою до водоспаду Женецький Гук (треба повернути ліворуч від КПП і йти пішки ще 8 км, маршрут має червоно-біле маркування).",
                    },
                ],
            },
            {
                title: "Легенда про Микуличин",
                img: {
                    img_1280: IMAGES.BLOG.LEGEND_1280,
                    img_768: IMAGES.BLOG.LEGEND_768,
                    img_300: IMAGES.BLOG.LEGEND_300,
                },
                content: [
                    {
                        h2: "",
                        img: "",
                        p: "За часів правління князя Данила Галицького був воєвода Микула, який був дуже вірний князю, одного разу прогулюючись карпатськими горами дуже вподобав собі цю місцину тай з великим захопленням розказав князю Данилу, той вислухавши наділив його чином і сказав: бери своїх вірних вояків тай іди розвивай той край , по приході в село скликав жителів, щоб встановити свій закон, і порядок люди добре сприйняли Микулу, на горі Ділок зробили діл (фортецю), яка слугувала як митниця, всі на той час купці які йшли з товаром на Закарпаття через село мусили платити податок, за рахунок того село розвивалися промисловість і сільське господарство, тоді громадою було вирішено назвати село Микули- чин. ",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Прогулювався боярин Микула із своїм військом по горах. Але одного разу забарився Микула. Обступило його військо вороже на високій горі, з усіх боків обступило. Нема де дітися. Та військо Микулене та й сам Микула не мали страху. Заспівали вони тоді патріотичні свої пісні. Їх спів, неначе грім великий, покотився по всіх горах — над Говерлою, над Прутцем, над Прутом. По всіх плаях карпатських. Перестрашилося вороже військо того співу, а їх старший наказав схопити Микулу.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "І забряжчали мечі, затріщали кольчуги, і полилася свіжа крівця ворогів. Б'ється, б'ється Микула, руба ворогів у пень, а кінця краю не видно: багато було воріженьків, та не перестрашився Микула, вибіг він на гору, що над річкою, став над нею і сміється з ворогів, а ті аж зубами скрегочуть. Кинулись на гору до нього, а він усіх їх перебив.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "І цю гору стали називати Микулинкою, а село — Микуличин.",
                    },
                ],
            },
            {
                title: "Релігія",
                img: {
                    img_1280: IMAGES.BLOG.CHURCH_1280,
                    img_768: IMAGES.BLOG.CHURCH_768,
                    img_300: IMAGES.BLOG.CHURCH_300,
                },
                content: [
                    {
                        h2: "Троїцька церква, 1868 р.",
                        img: "",
                        p: "Окрасою Микуличина є пам'ятка архітектури — церква Святої Трійці (1868 р.) і дзвіниця, яка побудована значно раніше. Розпис іконостасу виконав видатний український художник, поет і драматург Корнило Устияно́вич (1839–1903).",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Перші письмові згадки про місцеву церкву походять з 1700 р. Стара дерев'яна церква була розміщена на цвинтарі вище присілка Фальчі. У 1760-х рр. її зруйнував сильний буревій. Будівництво існуючої дерев'яної Троїцької церкви (розпочате у 1866 р.) завершилось у 1868 р. Церква була побудована за проектом цісарсько-королівського інженера архітектора Надвірнянського повітового уряду Я. Чайковецького. Влітку 1911 р. руйнівна повінь завдала селу чималих збитків. Тому в цей і наступний роки проводили ремонт церкви: покрили дах бляхою, а дзвіницю — ґонтом.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "В старовину хрести на банях церкви були дерев'яні. Сучасні металеві хрести та ґрати до церковних вікон були встановлені 1929 р.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "З 1927 року, коли з ініціативи митрополита Андрея Шептицького був побудований Станіславською єпархією в Микуличині основний будинок монастиря Згромадження Сестер Служебниць Непорочної Діви Марії, черниці здійснювали в селі християнську опіку, безкоштовно вели релігійне дошкільне виховання дітей до 8 років.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Під час Другої світової війни з церкви нацисти забрали 4 срібні дзвони. Найбільший з них важив 5 тонн. Його дзвін було чути в радіусі 12 км.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "По другій світовій війні церква була діючою. Сьогодні у церкві знаходиться 5 дзвонів, найбільший з яких важить 6 центнерів. У 2002 р. на воротах церкви споруджено нову дзвіницю. Церква є пам'яткою архітектури національного значення. Перебуває у користуванні громади УГКЦ.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "У наш час серед мешканців села історично переважають греко-католики. Після періоду переслідування церкви за радянських часів, греко-католицизм у селі відновився в грудні 1989 року. Ініціатором цього виступив парох села — о. Григорій Чиборак: оголосив у церкві мирянам, що вони мають право вирішити чи залишатися у підпорядкуванні Московського патріархату, чи повернутися до віри батьків — УГКЦ. Для цього кожному з них треба було підписатися в одному із трьох списків цих конфесій. Більше тисячі підписів було у списку УГКЦ і ні одного у списках інших конфесій.",
                    },
                ],
            },
            {
                title: "Розташування",
                img: {
                    img_1280: IMAGES.BLOG.LOCAL_1280,
                    img_768: IMAGES.BLOG.LOCAL_768,
                    img_300: IMAGES.BLOG.LOCAL_300,
                },
                content: [
                    {
                        h2: "Річка Прут в Микуличині.",
                        img: "",
                        p: "Микуличин знаходиться на висоті близько 750 метрів над рівнем моря. Село розташоване в долині річки Прут.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Найближчі населені пункти: Яремче, Татарів, Ворохта, Яблуниця, Поляниця (Буковель).",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Через село проходить залізниця із Рахів-Івано-Франківськ та автошлях Н09 Мукачеве — Львів.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "На залізничній станції Микуличин зупиняються приміські поїзди до Ворохти, Рахова, Франківська, Коломиї та Яремчого. Частину приміських рейсів уже замінили сучасним дизель-поїздом Pesa з усіма зручностями. Поїзди далекого сполучення курсують до Львова, а також до Києва через Хмельницький-Вінницю.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Найближчі гори в околицях Микуличин — г. Явірник—Горган (1467 м), г. Маковиця (985 м), г. Рокита Велика (1100 м), г. Костел (1049 м).",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Річки — Прут, Женець, Прутець Чемигівський. На північ від села знаходиться водоспад Капливець. Неподалік від Микуличина, на границі з Татаровим, розташовані водоспади: Женецький й Нарінецький.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "У селі річка Хичка, Копчик та струмок Форещинка впадають у Прутець Чемигівський.",
                    },
                ],
            },
            {
                title: "Магазини в Микуличині",
                img: {
                    img_1280: IMAGES.BLOG.SHOPING_1280,
                    img_768: IMAGES.BLOG.SHOPING_768,
                    img_300: IMAGES.BLOG.SHOPING_300,
                },
                content: [
                    {
                        h2: "Трохи про магазини Микуличина.",
                        img: {
                            img_1280: IMAGES.BLOG.SHOPING_1280,
                            img_768: IMAGES.BLOG.SHOPING_768,
                            img_300: IMAGES.BLOG.SHOPING_300,
                        },
                        p: "Микуличин - це кукрортне селище і звичайно ж у ньому є багато магазинів із сувенірами, продуктами харчування, господарськими товарами та іншими необхідними товарами для життя будь-якої людини. Найбільше скупчення магазинів розташовується в центрі селища, що приблизно знаходиться від садиби в межах 15 хвилин ходьби повільним кроком або 3-5 хвилин на машині. Але елементарні продукти Ви зможете купити за 100-200 метрів від проживання.",
                    },
                ],
            },
            {
                title: "Цікаві факти",
                img: {
                    img_1280: IMAGES.BLOG.FACTS_1280,
                    img_768: IMAGES.BLOG.FACTS_768,
                    img_300: IMAGES.BLOG.FACTS_300,
                },
                content: [
                    {
                        h2: "",
                        img: "",
                        p: "Микуличин відомий антифеодальним рухом селян, який отримав назву опришківства. У наш час село відоме завдяки рекреації, зеленому та сільському туризму. У селі збереглися дерев'яна Троїцька церква з дзвіницею (1863 р.).",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "У XIX столітті Микуличин носив неофіційний статус найбільшого села в Європі і найбільшого у Австро-Угорщині. Численні туристичні путівники вказують, що його територія простягалася на 44 кілометри — від Яремчого до кордону з Закарпаттям. Так тривало до 1927 року, коли польський уряд від’єднав від Микуличина Татарів, Ворохту і ще чимало дрібніших поселень, як-от знану нині Поляницю (Буковель). Однак і нині розміри села вражають. Воно розкинулося у долині Пруту на десять кілометрів.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Перші відпочивальники з’явилися в Микуличині ще наприкінці 1890-х одразу після того, як в ці куточки Карпат прийшла залізнична колія. Село стало розвиватися як кліматичний курорт. Власниками розкішних вілл були мешканці Коломиї, Львова та навіть Відня. За польських часів побудовано дитячі табори, які використовуються дотепер. Та загалом Микуличин завжди перебував у тіні своїх більш розкручених сусідів — Яремчи та Ворохти.",
                    },
                ],
            },
            {
                title: "Історія",
                img: {
                    img_1280: IMAGES.BLOG.HISTORY_1280,
                    img_768: IMAGES.BLOG.HISTORY_768,
                    img_300: IMAGES.BLOG.HISTORY_300,
                },
                content: [
                    {
                        h2: "",
                        img: "",
                        p: "За архівними документами першу письмову згадку про цей населений пункт датовано 1412 роком. У давнину воно було власністю князя Микули, від імені якого і походить його назва. У 1437 році в галицькому суді село згадується як Mykolincze. У 1448 році згадане село пол. Miculincze у Коломийському дистрикті. У податковому реєстрі 1515 року документується 1/2 лану (близько 12,5 га) оброблюваної землі.",
                    },
                    {
                        h2: "Археологічне минуле",
                        img: "",
                        p: "Панорама Микуличина з гори Маковиця. У 1960-1980-х роках у долині верхнього Пруту, куди входить і територія Микуличина з присілками, виявлено понад 50 археологічних пам'яток, що дозволяють відтворити історію цієї території за останні 40 тис. років. Найстаріші сліди життя мають 40 тисяч років, коли тут проживали нечисленні представники неандертальської людини, що характеризувалась низьким ростом, зігнутими в ліктях руками та в колінах ногами, відсутністю підборіддя, великими надбрівними дугами під нахиленим назад чолом.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "З кінця палеоліту — початку мезоліту походять численні знахідки з урочищ Кливка і Чопа, Царина, Поляна, Жбир. Знахідки представлені довгими призматичними ядрищами, шкребками, різцями, наконечниками стріл у вигляді вербових листків.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Населення палеолітичних та мезолітичних часів займалось, насамперед, ловецтвом, харчувалось м'ясом диких звірів, одягалося в шкіри. Мешкали невеличкими родовими групами у колибах дерев'яної конструкції, вкритих шкірами мамонтів. Наступні сліди життя людини у долині верхнього Пруту зафіксовані з часів Київської Русі.",
                    },
                    {
                        h2: "Антифеодальна боротьба",
                        img: "",
                        p: "Шляхтич Анджей Белжецький був власником маєтків у Микуличині.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Перші дані про кількість населення Микуличина та всіх його великих присілків відносяться до XVII століття. Тоді тут було 86 будинків, у яких проживало 473 особи. У Микуличині та Ямні нараховувалось 3,5 ланів та 60 голів великої рогатої худоби.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Щотижня для магнатів Белз(ж)ецьких відробляли 1-2 дні пішої чи тягової панщини, часто працювали при обслузі дворів, будівництві замкових укріплень, брали участь у сімейних війнах феодалів. Антифеодальний рух розпочався стихійно, незалежно від загальнополітичних обставин, у надії на власні сили, що якісно відрізняє його від селянських виступів 1648 р. в околицях Делятина. Цей рух отримав назву опришківства.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Першим ватажком опришків, що діяли у верхів'ях Пруту, був Нестор, покараний за свою діяльність судом у Селянині в 1681 р. Великого розголосу наробили операції хороброго опришківського ватажка Івана Пискливого. У 1703 році його опришки діяли в Фотинії і Березові, у Микуличині, де на подвір'ї вбили зненавидженого отамана Гната і слугу, що інформував шляхту про рухи опришків.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "У 1738 році вперше в долині Пруту появились опришки Олекси Довбуша, які напали і пограбували багачів з Чорних Ослав. У 1741 р. цей загін вів кількаденний бій з микуличинцями, що охороняли на рокитнянській дорозі кутських купців. З обидвох сторін були жертви, а в Микуличині спалено кілька будинків. У перших роках опришківської діяльності Довбуша в його ватазі знаходилися і деякі мешканці Микуличина, зокрема брати Яворівці, Федір Никорак та Іван Кошак. Відтак, до ватаги Довбуша пристав його сестрінок Павло Орфенюк з Ямни та Василь Баюрак з Дори. Довбушеві побратими мали по селах таких своїх однодумців як Павло та Степан Дроніви з Ямни та дрібних шляхтичів з Ослав, що постачали загін харчами та зброєю.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "У Ворохті смолякам вдалось залучити до висліджування опришків найбагатшого у селі Мочерняка, у Космачі Дзвінчука. У 1745 році Довбуш постановив розправитися з ними. З Ясині, де певний час перебував, він з своїми товаришами Орфенюком та Баюраком подався до сестри в Ямні. Тоді ж Баюрак відвідав своїх рідних у Дорі. Після цього вони верхами повернулись до Ворохти, вбили там Мочерняка, його господарство спалили. Звідти направилися до Космача щоби розправитися з Дзвінчуком, але останній заздалегідь довідався про наміри Довбуша, підготувався його зустріти кулею і убив ватажка опришків. Це сталось вночі з 23 на 24 серпня 1745 року. Після смерті тіло Довбуша пошматували, куски на пострах населенню повісили на палях у Микуличині та Чорному Потоці.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Після смерті Довбуша на деякий час рух опришків припинився. Лише в 1749 р. Семен Баюрак з Дори разом зі своїм сином та дорянами Ільком Семеновим і Андрієм Дроботяковим організували загін, до якого пристали один легінь з Микуличина та два легіні з Ямни і вчинили напад на корчмаря у Стопчатові. Напад був невдалим, Семен з деякими побратимами попалися до рук карателів. На цьому основні виступи опришків проти феодалів закінчилися.",
                    },
                    {
                        h2: "Під Австрійською владою",
                        img: "",
                        p: "У 1781 році з 775 мешканців було 763 українців та 12 євреїв, у 1900 — із 4306 жителів — 3429 українців, 268 поляків та 608 євреїв. За даними в Микуличині у 1880 році було 75155 моргів землі, у тому числі: 366 — рілля, 5089 — луки, 25 — городи, 8418 — пасовища, 5322 — полонини, 54279 — ліси. Така площа, не могла забезпечити потреби населення у зернових культурах та городині, тому у горах селяни займалися, насамперед, тваринництвом.",
                    },
                ],
            },
            {
                title: "Розваги",
                img: {
                    img_1280: IMAGES.BLOG.ENTERTAINMENT_1280,
                    img_768: IMAGES.BLOG.ENTERTAINMENT_768,
                    img_300: IMAGES.BLOG.ENTERTAINMENT_300,
                },
                content: [
                    {
                        h2: "Піші прогулянки по горах.",
                        img: {
                            img_1280: IMAGES.BLOG.WALKS_1280,
                            img_768: IMAGES.BLOG.WALKS_768,
                            img_300: IMAGES.BLOG.WALKS_300,
                        },
                        p: "Гора Ягідна (1216 м). До неї від зупинки автобуса веде лісова дорога: підйом нескладний, крутих ділянок практично не зустрічається, йти на вершину ґрунтовою дорогою близько 2-3 годин (залежно від погодних умов, стану дороги та особистого настрою мандрівників). До Ягідної з центру Микуличина – 7 км. З гори відкривається широка панорама на найвищий гірський хребет України – Чорногорський. На вершині Ягідної ви виявите дерев'яну альтанку: де буде відпочити і вдосталь налюбуватися гірськими пейзажами! Захопіть із собою бутерброди, термос та шоколадний батончик — чисте гірське повітря та двогодинний підйом обов'язково розбудять почуття голоду! Велика перевага цього простенького маршруту в тому, що його можна дозволити собі і влітку, і взимку: поблизу Ягідної є полонина Лиснів, там розташована гуцульська колиба з дров'яною піччю та широкими лежанками, а цього цілком достатньо для комфортного та безпечного ночівлі подалі від зручностей селища.", 
                    },
                    {
                        h2: "Покупки у Микуличині.",
                        img: {
                            img_1280: IMAGES.BLOG.SHOPING_1280,
                            img_768: IMAGES.BLOG.SHOPING_768,
                            img_300: IMAGES.BLOG.SHOPING_300,
                        },
                        p: `Новий торговий комплекс Hutsul Plaza (2020) розташований серед Карпатських гір, що поблизу Буковеля, на першій лінії від центральної дороги Яремче-Буковель. «Hutsul Plaza» – це 1000 м2, що поєднують сучасний стиль, вишуканість, трендові дизайнерські та ландшафтні рішення. Для відвідувачів комплексу «Hutsul Plaza» гарантуємо море позитивних емоцій від шопінгу, веселий настрій та чудовий час під час організації розважальних програм, святкувань, проведення ярмарків, конкурсів, дегустацій, фестивалів.`,
                    },
                    {
                        h2: "Церква Святої Трійці (1868 р.).",
                        img: {
                            img_1280: IMAGES.BLOG.CHURCH_1280,
                            img_768: IMAGES.BLOG.CHURCH_768,
                            img_300: IMAGES.BLOG.CHURCH_300,
                        },
                        p: "Окрасою Микуличина є пам'ятка архітектури — церква Святої Трійці (1868 р.) і дзвіниця, яка побудована значно раніше. Розпис іконостасу виконав видатний український художник, поет і драматург Корнило Устияно́вич (1839–1903).",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Перші письмові згадки про місцеву церкву походять з 1700 р. Стара дерев'яна церква була розміщена на цвинтарі вище присілка Фальчі. У 1760-х рр. її зруйнував сильний буревій. Будівництво існуючої дерев'яної Троїцької церкви (розпочате у 1866 р.) завершилось у 1868 р. Церква була побудована за проектом цісарсько-королівського інженера архітектора Надвірнянського повітового уряду Я. Чайковецького. Влітку 1911 р. руйнівна повінь завдала селу чималих збитків. Тому в цей і наступний роки проводили ремонт церкви: покрили дах бляхою, а дзвіницю — ґонтом.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "В старовину хрести на банях церкви були дерев'яні. Сучасні металеві хрести та ґрати до церковних вікон були встановлені 1929 р.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "З 1927 року, коли з ініціативи митрополита Андрея Шептицького був побудований Станіславською єпархією в Микуличині основний будинок монастиря Згромадження Сестер Служебниць Непорочної Діви Марії, черниці здійснювали в селі християнську опіку, безкоштовно вели релігійне дошкільне виховання дітей до 8 років.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Під час Другої світової війни з церкви нацисти забрали 4 срібні дзвони. Найбільший з них важив 5 тонн. Його дзвін було чути в радіусі 12 км.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "По другій світовій війні церква була діючою. Сьогодні у церкві знаходиться 5 дзвонів, найбільший з яких важить 6 центнерів. У 2002 р. на воротах церкви споруджено нову дзвіницю. Церква є пам'яткою архітектури національного значення. Перебуває у користуванні громади УГКЦ.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "У наш час серед мешканців села історично переважають греко-католики. Після періоду переслідування церкви за радянських часів, греко-католицизм у селі відновився в грудні 1989 року. Ініціатором цього виступив парох села — о. Григорій Чиборак: оголосив у церкві мирянам, що вони мають право вирішити чи залишатися у підпорядкуванні Московського патріархату, чи повернутися до віри батьків — УГКЦ. Для цього кожному з них треба було підписатися в одному із трьох списків цих конфесій. Більше тисячі підписів було у списку УГКЦ і ні одного у списках інших конфесій.",
                    },
                    {
                        h2: "Водоспад Женецький (Гук).",
                        img: {
                            img_1280: IMAGES.BLOG.WATERFALL_1280,
                            img_768: IMAGES.BLOG.WATERFALL_768,
                            img_300: IMAGES.BLOG.WATERFALL_300,
                        },
                        p: "Однокаскадний 15-метровий красень затишно розташувався в компанії смерекового лісу та кам'янистих Ґорґан. Знаходиться в заповідному урочищі Женець на однойменній річці. До Гука легко доїхати і навіть дійти. Це один з небагатьох карпатських водоспадів, до якого веде чудова асфальтована дорога. І нехай вона триває лише 3 км, а решта 3 км доведеться прогулятися класичною гірською ґрунтовкою злегка розмитою дощами та роз'їждженою автомобілями. Але шлях того вартий: Гук — високий і витончений: влітку не пересихає, а взимку вбирається вишуканими бурульками, тому будь-якої пори року ви не пошкодуєте, що прийшли сюди!",
                    },
                    {
                        h2: `Пивоварня "Мікуличин".`,
                        img: {
                            img_1280: IMAGES.BLOG.BREWERY_1280,
                            img_768: IMAGES.BLOG.BREWERY_768,
                            img_300: IMAGES.BLOG.BREWERY_300,
                        },
                        p: `Відкрита 2002 року пивоварня варить пиво натуральним способом, випускаючи його у продаж під торговою маркою “Гуцульське”. Не варто шукати великих бетонних споруд, звичних для ока городянина з промислових міст: у Микуличині пиво варять у невеликому дерев'яному будинку, де дивом розміщується ділянка пивоваріння та технічні відділи. Обладнання для виробництва пива поставили з Угорщини, а змонтували в класичній гуцульській хаті, яку на вигляд складно виділити з таких же будов навколо. За задумом власника, виробництво натурального пива має гармоніювати з навколишнім світом та культурою краю. Бродіння "Гуцульського" триває 7 днів і ще 14 днів пиво дозріває. Тут варять Медове та Темне, Світле “Ювілейне” та Біле “Гуцульське”. Мед, між іншим, для Медового пива одержують із власної пасіки. На територію броварні можна пройти з екскурсією, записатися на дегустацію пива та заглянути у фірмовий магазин за пінним трофеєм. Знайти магазин не проблема: у самому центрі Микуличина знаходиться невеликий, акуратненький будиночок з фірмовою вивіскою - повз не пройти і не проїхати!`,
                    },
                ],
            },
        ],
        footer: [ 
            {
                title: "Адреса:",
                text_1: "вулиця Грушевського",
                text_2: "78590, Микуличин",
                text_3: "Івано-Франківська область",
                text_4: "Україна",
            },
            {
                title: "Телефони:",
                text_1: "+380343439401",
            },
            {
                title: "Социальні мережі:",
            },
        ],
    },

    ru: {
        //heder
        logoSite: `Микуличин`,
        subTitle: "Добро пожаловать в Карпаты!",
        description: "Чистый воздух, прекрасные горы, свежесваренное пиво ждут именно Вас!",
        metaDescription: "Чистый воздух, прекрасные горы, свежесваренное пиво, пеший туризм, походы по горам, лыжный курорт, зимние развлечения",
        metaKeywords: "Микуличин, отдых в горах, походы в горы, зимний отдых, лыжный курорт, карпатские чаны",
        message: "Написать нам",
        hotelOpenList: "Открыть список отелей",
        btn: {
            text: "Реклама на сайте",
            email: "Отправить сообщение",
            hotel: "Перейти на сайт",
            phone:  "+380971644422",
            phoneLink: "tel:+380971644422",
            emailLink: "mailto:mikulichin@online.ua",
            img: ICONS.PHONE,
        },
        nav: {
            about: "О нас",
            hotels: "Отели",
            blog: "Блог",
            gallery: "Галерея",
            contact: "Контакты",
        },
        service: [
            {
                src: ICONS.LOCATION, 
                title: "Расположение", 
                text: "Микуличин находится на высоте около 750 метров над уровнем моря. Деревня расположена в долине реки Прут.",
            },
            {
                src: ICONS.FOOD, 
                title: "Магазины", 
                text: "В Микуличине есть магазины с сувенирами, продуктами питания, хозяйственными и другими полезными товарами.",
            },
            {
                src: ICONS.SAUNA, 
                title: "Развлечениия", 
                text: "Пешие прогулки по горам, свежесваренное пиво, рестораны, карпатские чаны, старинная церковь, водопад и другое.",
            },
        ],
        gallery: [
            {
                src : {
                    src_1280: IMAGES.GALLERY.GALLERY_1_1280, 
                    src_768: IMAGES.GALLERY.GALLERY_1_768,
                    src_300: IMAGES.GALLERY.GALLERY_1_300,
                },
                title: "Кадыба для приготовления продуктов на открытом огне.",
            },
            {
                src : {
                    src_1280: IMAGES.GALLERY.GALLERY_2_1280, 
                    src_768: IMAGES.GALLERY.GALLERY_2_768,
                    src_300: IMAGES.GALLERY.GALLERY_2_300,
                },
                title: "Экстерьер гостинницы со стороны прилегающей территории.",
            },
            {
                src : {
                    src_1280: IMAGES.GALLERY.GALLERY_3_1280, 
                    src_768: IMAGES.GALLERY.GALLERY_3_768,
                    src_300: IMAGES.GALLERY.GALLERY_3_300,
                },
                title: "Зал для отдыха возле чана.",
            },
            {
                src : {
                    src_1280: IMAGES.GALLERY.GALLERY_4_1280, 
                    src_768: IMAGES.GALLERY.GALLERY_4_768,
                    src_300: IMAGES.GALLERY.GALLERY_4_300,
                },
                title: "Типовой интерьер одного из номеров класса 'Стандарт'.",
            },
        ],
        aboutTitle: "Микуличин - гарантия хорошего настроения!",
        aboutText: "Микуличин — село в Ивано-Франковской области, подчиненное Яремчанскому горсовету. Низкогорный климатический курорт расположен в долине реки Прута. Украшением Микуличина является памятник архитектуры — церковь Святой Троицы (1868 г.) и построенная значительно раньше колокольня.",
        aboutImg: [
            {
                src: IMAGES.ABOUT.MYKULYCHYN, 
                title: "Прекрасный вид на Микуличин.",
            },
            {
                src: IMAGES.ABOUT.MYKULYCHYN_GERB, 
                title: "Герб Микуличина.",
            },
            {
                src: IMAGES.ABOUT.MYKULYCHYN_PRAPOR, 
                title: "Флаг Микуличина.",
            },
        ],
        review: [
            {
                title: "Сказочные места", 
                text: "Были в августе, ходили в горы по грибы и ягоды. Сядишь на пенек отдохнуть, руку протянишь и ягода в твоей руке.", 
                img: IMAGES.REVIEW.REVIEW_1, 
                auhtor: "Николай, Харьков",
                rating: [1,2,3,4,5],
            },
            {
                title: "Зеленые горы", 
                text: "Все горы в округе пышат зеленью, воздух чистейший, идешь и наслаждаешься одновременно красотой чистым воздухом.", 
                img: IMAGES.REVIEW.REVIEW_2, 
                auhtor: "Полина, Киев",
                rating: [1,2,3,4,5],
            },
            {
                title: "Горные реки", 
                text: "Вдоль трассы Ивано-Франковск - Буковель протекает насколько горных рек, очень красиво, летом можно даже охладиться.", 
                img: IMAGES.REVIEW.REVIEW_3, 
                auhtor: "Ярослав, Херсон",
                rating: [1,2,3,4,5],
            },
            {
                title: "Идеальное место", 
                text: "Отдыхали в частном доме у хозяев, прямо у подножия гор. Находились на весь год, но в следующем году приедем еще.", 
                img: IMAGES.REVIEW.REVIEW_4, 
                auhtor: "Ольга, Винница",
                rating: [1,2,3,4,5],
            },
            {
                title: "Мы в восторге", 
                text: "Мы в восторге, нам все понравилось. Очень вкусное местное пиво, рекомендую ценителям, ну и волшебная природа вокруг.", 
                img: IMAGES.REVIEW.REVIEW_5, 
                auhtor: "Светлана, Хмельницький",
                rating: [1,2,3,4,5],
            },
            {
                title: "Все нравится", 
                text: "Если надоел город и Вы работаете на дому, здесь прекрасно подходит для удаленной работы, хороший интернет и вкусная еда.", 
                img: IMAGES.REVIEW.REVIEW_6, 
                auhtor: "Виктория, Кировоград",
                rating: [1,2,3,4,5],
            },
            {
                title: "Приемлемые цены", 
                text: "Отдыхали зимой. Кататься ездили в Буковель, но жили здесь. Меньше суеты и приемлемые цены. Еще есть, где поставить машину.", 
                img: IMAGES.REVIEW.REVIEW_7, 
                auhtor: "Геннадий, Чернигов",
                rating: [1,2,3,4,5],
            },
            {
                title: "Семейный отдых", 
                text: "Отличное место для семейного отдыха. Недорого, красивая природа, вокруг много магазинов, есть ресторан, пицерия, суши бар.", 
                img: IMAGES.REVIEW.REVIEW_8, 
                auhtor: "Ольга, Полтава",
                rating: [1,2,3,4,5],
            },
            {
                title: "Хочу вернутся", 
                text: "Очень удачное расположение к локациям. Поблизости есть горы, долина и река. Распологает к прогулкам. Хочется вернуться.", 
                img: IMAGES.REVIEW.REVIEW_9, 
                auhtor: "Петр, Николаев",
                rating: [1,2,3,4,5],
            },
        ],

        hotelsTitle: "Реклама на сайте",
        hotels: [
            {
                title: "Название отеля",
                img: IMAGES.HOTELS.HOTEL1,
                link: "https://www.google.com/",
                rating: [1,2,3,4,5],
                lable: [
                    {
                        new: "",
                    },
                    {
                        hot: "",
                    },
                    {
                        other: "Завтрак бесплатно!",
                    },
                ],
                phone: "+0000000000000",
                description: "Краткое описание отеля – пример, пример, пример, пример, пример, пример, пример, пример, пример, пример, пример, пример, пример, пример, пример.",
            },
            {
                title: "Название отеля",
                img: IMAGES.HOTELS.HOTEL2,
                link: "https://www.google.com/",
                rating: [1,2,3,4],
                lable: [
                    {
                        new: "Новый отель",
                    },
                    {
                        hot: "",
                    },
                    {
                        other: "",
                    },
                ],
                phone: "+0000000000000",
                description: "Краткое описание отеля – пример, пример, пример, пример, пример, пример, пример, пример, пример, пример, пример, пример, пример, пример, пример.",
            },
            {
                title: "Название отеля",
                img: IMAGES.HOTELS.HOTEL3,
                link: "https://www.google.com/",
                rating: [1,2,3],
                lable: [
                    {
                        new: "",
                    },
                    {
                        hot: "Горячее предложение!",
                    },
                    {
                        other: "",
                    },
                ],
                phone: "+0000000000000",
                description: "Краткое описание отеля – пример, пример, пример, пример, пример, пример, пример, пример, пример, пример, пример, пример, пример, пример, пример.",
            },
            {
                title: "Название отеля",
                img: IMAGES.HOTELS.HOTEL4,
                link: "https://www.google.com/",
                rating: [1,2,3,4],
                lable: [
                    {
                        new: "",
                    },
                    {
                        hot: "",
                    },
                    {
                        other: "Вид на горы",
                    },
                ],
                phone: "+0000000000000",
                description: "Краткое описание отеля – пример, пример, пример, пример, пример, пример, пример, пример, пример, пример, пример, пример, пример, пример, пример.",
            },

        ],

        blog: [
            {
                title: "Природная красота Микуличина",
                img: {
                    img_1280: IMAGES.BLOG.WATERFALL_1280,
                    img_768: IMAGES.BLOG.WATERFALL_768,
                    img_300: IMAGES.BLOG.WATERFALL_300,
                },
                content: [
                    {
                        h2: "Водопад Женецкий Гук",
                        img: {
                            img_1280: IMAGES.BLOG.WATERFALL_1280,
                            img_768: IMAGES.BLOG.WATERFALL_768,
                            img_300: IMAGES.BLOG.WATERFALL_300,
                        },
                        p: "Один из самых высоких карпатских водопадов – его высота 15 м, а сам он находится на высоте около 900 м над уровнем моря. От села Микуличин до водопада – 8 км, и чтобы добраться на него, надо сесть на любой рейсовый автобус и выйти перед поворотом на Гук. Далее дорогу укажут указатели. Перейдя железнодорожные пути вы увидите контрольно-пропускной пункт, где потребуется оплатить проход к водопаду (со взрослого около 10 грн, за ребенка – дешевле, за проезд автотранспорта взимается отдельная плата). Далее по асфальтовой дороге придется идти 1-1,5 часа, затем дорога сменится на грунтовку. Весь маршрут промаркирован, главное идти строго по указателям. Недалеко от водопада расположился сувенирный рынок, где можно купить карпатские травяные чаи, выпить глинтвейн или горячий кофе, что особенно приятно в холодную пору. У водопада есть беседки и скамейки, оборудованы смотровые площадки с лесенками и перилами, рядом находится небольшое кафе-колыба. Место пользуется популярностью у туристов в любое время года, поэтому ехать к водопаду желательно пораньше, чтобы успеть насладиться природой в тишине.",
                    },
                    {
                        h2: "Гора Костел.",
                        img: {
                            img_1280: IMAGES.BLOG.MOUNTAINCHURCH_1280,
                            img_768: IMAGES.BLOG.MOUNTAINCHURCH_768,
                            img_300: IMAGES.BLOG.MOUNTAINCHURCH_300,
                        },
                        p: "Pасположена в 4,5 км к востоку от Микуличина. Подъем можно начать от автомобильного моста через реку Прутец Чемиговский. Вершину горы венчает большая скала с плоским верхом в окружении более мелких камней. С нее открывается завораживающий вид на горные хребты Горганы, на Петрос и Говерлу.На гору можно подняться самостоятельно или заказать тур на внедорожнике практически до вершины (такие экскурсии предлагают в отелях и усадьбах).",
                    },
                    {
                        h2: "Гора Ягодная.",
                        img: {
                            img_1280: IMAGES.BLOG.BERRYMOUNTAIN_1280,
                            img_768: IMAGES.BLOG.BERRYMOUNTAIN_768,
                            img_300: IMAGES.BLOG.BERRYMOUNTAIN_300,
                        },
                        p: "Дорога, ведущая к ней, начинается прямо от автобусной остановки. Подъем несложный, без крутых участков. До вершины Ягодной идти часа 2-3, но это того стоит – с вершины открывается шикарный вид на Черногорский хребет. На вершине Ягодной есть беседка – можно отдохнуть, перекусить и вдоволь налюбоваться открывающимися пейзажами.",
                    },
                    {
                        h2: "Гора Маковица.",
                        img: {
                            img_1280: IMAGES.BLOG.MOUNTAINMAKOVITSA_1280,
                            img_768: IMAGES.BLOG.MOUNTAINMAKOVITSA_768,
                            img_300: IMAGES.BLOG.MOUNTAINMAKOVITSA_300,
                        },
                        p: "То одна из самых высоких гор Яремче. Путь займет 1,5-2 часа. По центральной улице надо будет пройти в сторону улицы Горной и дальше в сторону Маковицы. На ее вершине стоит металлический крест, а при восхождении можно увидеть окопы и найти гильзы – следы минувших войн.",
                    },
                    {
                        h2: "Горы Хомяк и Синяк.",
                        img: {
                            img_1280: IMAGES.BLOG.MOUNTAINHAMSTER_1280,
                            img_768: IMAGES.BLOG.MOUNTAINHAMSTER_768,
                            img_300: IMAGES.BLOG.MOUNTAINHAMSTER_300,
                        },
                        p: "Поход осилят и новички, и дети, так как перепад высот небольшой, а на дорогах нет особых препятствий. Один из маршрутов на г. Хомяк как раз пролегает по дороге к водопаду Женецкий Гук (надо повернуть налево от КПП и идти пешком еще 8 км, маршрут имеет красно-белую маркировку).",
                    },
                ],
            },
            {
                title: "Легенда про Микуличин",
                img: {
                    img_1280: IMAGES.BLOG.LEGEND_1280,
                    img_768: IMAGES.BLOG.LEGEND_768,
                    img_300: IMAGES.BLOG.LEGEND_300,
                },
                content: [
                    {
                        h2: "",
                        img: "",
                        p: "Во времена правления князя Даниила Галицкого был воевода Микула, который был очень верен князю, однажды прогуливаясь по карпатским горам очень понравился себе это место и с большим восхищением рассказал князю Даниле, тот выслушав наделил его образом и сказал: бери своих верных воинов край , по приходу в деревню созвал жителей, чтобы установить свой закон, и порядок люди хорошо восприняли Микулу, на горе Делок сделали дел (крепость), которая служила как таможня, все в то время купцы шедшие с товаром на Закарпатье через село должны платить налог, за счет того село развивались промышленность и сельское хозяйство, тогда общиной было решено назвать село Микуличин.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Прогуливался боярин Микула со своим войском по горам. Но однажды замешкался Микула. Обступило его войско враждебно на высокой горе, обступило со всех сторон. Негде деться. Но войско Микулене и сам Микула не имели страха. Пели они тогда патриотические свои песни. Их пение, как гром большой, покатилось по всем горам — над Говерлой, над Прутцем, над Прутом. По всем карпатским плаям. Перепугалось вражеское войско того пения, а их старший приказал схватить Микулу.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "И загремели мечи, затрещали кольчуги, и полилась свежая кровь врагов. Бьется, бьется Микула, рубит врагов в пень, а конца края не видно: много было врагов, но не перепугался Микула, выбежал он на гору над рекой, стал над ней и смеется над врагами, а те даже зубами скрежещут. Бросились к нему, а он всех их перебил.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "И эту гору стали называть Микулинкой, а село Микуличин.",
                    },
                ],
            },
            {
                title: "Религия",
                img: {
                    img_1280: IMAGES.BLOG.CHURCH_1280,
                    img_768: IMAGES.BLOG.CHURCH_768,
                    img_300: IMAGES.BLOG.CHURCH_300,
                },
                content: [
                    {
                        h2: "Троицкая церковь, 1868",
                        img: "",
                        p: "Украшением Микуличина является памятник архитектуры — церковь Святой Троицы (1868 г.) и построенная значительно раньше колокольня. Роспись иконостаса исполнил выдающийся украинский художник, поэт и драматург Корнило Устиянович (1839–1903).",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Первые письменные упоминания о местной церкви происходят с 1700 г. Старая деревянная церковь была размещена на кладбище выше поселка Фальчи. В 1760-х гг. ее разрушил сильный ураган. Строительство существующей деревянной Троицкой церкви (начавшееся в 1866 г.) завершилось в 1868 г. Церковь была построена по проекту цесарско-королевского инженера архитектора Надворнянского уездного правительства Я. Чайковецкого. Летом 1911 г. разрушительное наводнение нанесло селу немалый ущерб. Поэтому в этот и последующие годы проводили ремонт церкви: покрыли крышу жестью, а колокольню — гонтом.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "В старину кресты на куполах церкви были деревянные. Современные металлические кресты и решетки к церковным окнам были установлены в 1929 г.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "С 1927 года, когда по инициативе митрополита Андрея Шептицкого был построен Станиславской епархией в Микуличине основное здание монастыря Конгрегации Сестер Служебниц Непорочной Девы Марии, монахини осуществляли в селе христианскую опеку, бесплатно вели религиозное дошкольное воспитание детей.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Во время Второй мировой войны из церкви нацисты забрали 4 серебряных колокола. Самый большой из них весил 5 тонн. Его звон был слышен в радиусе 12 км.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "После второй мировой войны церковь была действующей. Сегодня в церкви находится 5 колоколов, самый большой из которых весит 6 центнеров. В 2002 г. на воротах церкви построена новая колокольня. Церковь является памяткой архитектуры национального значения. Состоит в пользовании общины УГКЦ.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "В настоящее время среди жителей села исторически преобладают греко-католики. После периода преследования церкви в советское время, греко-католицизм в деревне возобновился в декабре 1989 года. Инициатором этого выступил священник села — о. Григорий Чиборак: объявил в церкви мирянам, что они вправе решить или оставаться в подчинении Московского патриархата или вернуться к вере родителей — УГКЦ. Для этого каждому из них нужно было подписаться в одном из трех списков этих конфессий. Более тысячи подписей было в списке УГКЦ и ни одной в списках других конфессий.",
                    },
                ],
            },
            {
                title: "Расположение",
                img: {
                    img_1280: IMAGES.BLOG.LOCAL_1280,
                    img_768: IMAGES.BLOG.LOCAL_768,
                    img_300: IMAGES.BLOG.LOCAL_300,
                },
                content: [
                    {
                        h2: "Река Прут в Микуличине.",
                        img: "",
                        p: "Микуличин находится на высоте около 750 метров над уровнем моря. Деревня расположена в долине реки Прут.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Ближайшие населённые пункты: Яремче, Татаров, Ворохта, Яблуница, Поляница (Буковель).",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Через село проходит железная дорога из Рахов-Ивано-Франковск и автодорога Н09 Мукачево — Львов.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "На железнодорожной станции Микуличин останавливаются пригородные поезда в Ворохту, Рахов, Франковск, Коломыю и Яремче. Часть пригородных рейсов уже заменили современным дизель-поездом Pesa со всеми удобствами. Поезда дальнего сообщения курсируют во Львов, а также в Киев через Хмельницкий-Винницу.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Ближайшие горы в окрестностях Микуличин - г. Явирник-Горган (1467 м), г. Маковица (985 м), г. Рокита Большая (1100 м), г. Костел (1049 м).",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Реки - Прут, Женец, Прутец Чемыговский. Севернее села находится водопад Капливец. Недалеко от Микуличина, на границе с Татаровым, расположены водопады: Женецкий и Наринецкий.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "В селе река Хичка, Копчик и ручей Форещинка впадают в Прутец Чемыговский.",
                    },
                ],
            },
            {
                title: "Магазины в Микуличине",
                img: {
                    img_1280: IMAGES.BLOG.SHOPING_1280,
                    img_768: IMAGES.BLOG.SHOPING_768,
                    img_300: IMAGES.BLOG.SHOPING_300,
                },
                content: [
                    {
                        h2: "Немного о магазинах Микуличина",
                        img: {
                            img_1280: IMAGES.BLOG.SHOPING_1280,
                            img_768: IMAGES.BLOG.SHOPING_768,
                            img_300: IMAGES.BLOG.SHOPING_300,
                        },
                        p: "Микуличин - это кукрортный поселок и конечно же в нем есть много магазинов с сувенирами, продуктами питания, хозяйственными товарами и другими необходимыми товарами для жизни любого человека. Самое большое скопление магазинов располагается в центре поселка, что примерно находится от усадьбы в пределах 15 минут ходьбы неспешным шагом или 3-5 минут на машине. Но элементарные продукты Вы сможете купить в 100-200 метрах от проживания.",
                    },
                ],
            },
            {
                title: "Интересные факты",
                img: {
                    img_1280: IMAGES.BLOG.FACTS_1280,
                    img_768: IMAGES.BLOG.FACTS_768,
                    img_300: IMAGES.BLOG.FACTS_300,
                },
                content: [
                    {
                        h2: "",
                        img: "",
                        p: "Микуличин известен антифеодальным движением крестьян, получивший название опришковства. В настоящее время село известно благодаря рекреации, зеленому и сельскому туризму. В деревне сохранилась деревянная Троицкая церковь с колокольней (1863 г.).",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "В XIX веке Микуличин носил неофициальный статус крупнейшей деревни в Европе и крупнейшей в Австро-Венгрии. Многочисленные туристические путеводители указывают, что его территория простиралась на 44 километра — от Яремчего до границы с Закарпатьем. Так продолжалось до 1927 года, когда польское правительство отсоединило от Микуличина Татаров, Ворохту и еще немало мелких поселений, таких как известная ныне Поляница (Буковель). Однако и сейчас размеры села поражают. Она раскинулась в долине Прута на десять километров.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Первые отдыхающие появились в Микуличине еще в конце 1890-х сразу после того, как в эти уголки Карпат пришел железнодорожный путь. Деревня стала развиваться как климатический курорт. Владельцами роскошных вилл были жители Коломыи, Львова и даже Вены. В польское время построены детские лагеря, которые используются до сих пор. Но, в общем, Микуличин всегда находился в тени своих более раскрученных соседей — Яремчи и Ворохты.",
                    },
                ],
            },
            {
                title: "История",
                img: {
                    img_1280: IMAGES.BLOG.HISTORY_1280,
                    img_768: IMAGES.BLOG.HISTORY_768,
                    img_300: IMAGES.BLOG.HISTORY_300,
                },
                content: [
                    {
                        h2: "",
                        img: "",
                        p: "По архивным документам первое письменное упоминание об этом населенном пункте датировано 1412 годом. В древности оно являлось собственностью князя Микулы, от имени которого и произошло его название. В 1437 году в галицком суде деревня упоминается как Mykolincze. В 1448 году упомянуто село Пол. Miculincze в Коломыйском дистрикте. В налоговом реестре 1515 г. документируется 1/2 лана (около 12,5 га) обрабатываемой земли.",
                    },
                    {
                        h2: "Археологическое прошлое",
                        img: "",
                        p: "Панорама Микуличина с горы Маковица. В 1960-1980-х годах в долине верхнего Прута, куда входит и территория Микуличина с приселками, обнаружено более 50 археологических памятников, позволяющих воссоздать историю этой территории за последние 40 тыс. лет. Самые старые следы жизни имеют 40 тысяч лет, когда здесь проживали немногочисленные представители неандертальского человека, характеризовавшегося низким ростом, согнутыми в локтях руками и в коленях ногами, отсутствием подбородка, большими надбровными дугами под наклоненным назад лбом.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "С конца палеолита – начала мезолита происходят многочисленные находки из урочищ Кливка и Чопа, Царина, Поляна, Жбир. Находки представлены длинными призматическими ядрищами, скребками, резцами, наконечниками стрел в виде ивовых листьев.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Население палеолитических и мезолитических времен занималось, прежде всего, ловцом, питалось мясом диких зверей, одевалось в шкуры. Жили небольшими родовыми группами в хижинах деревянной конструкции, покрытых шкурами мамонтов. Следующие следы жизни человека в долине верхнего Прута зафиксированы со времен Киевской Руси.",
                    },
                    {
                        h2: "Антифеодальная борьба",
                        img: "",
                        p: "Шляхтич Анджей Белжецкий был владельцем имений в Микуличине.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Первые данные о численности населения Микуличина и всех его больших поселений относятся к XVII веку. Тогда здесь было 86 домов, в которых проживало 473 человека. В Микуличине и Ямне насчитывалось 3,5 полей и 60 голов крупного рогатого скота.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Еженедельно для магнатов Белз(ж)ецких отрабатывали 1-2 дня пешей или тяговой барщины, часто работали при обслуживании дворов, строительстве замковых укреплений, участвовали в семейных войнах феодалов. Антифеодальное движение началось стихийно, независимо от общеполитических обстоятельств в надежде на собственные силы, что качественно отличает его от крестьянских выступлений 1648 г. в окрестностях Делятина. Это движение получило название опришковства.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Первым предводителем опришков, действовавших в верховьях Прута, был Нестор, наказанный за свою деятельность судом в Крестьянине в 1681 г. Большую огласку наделали операции храброго опришковского предводителя Ивана Пыскливого. В 1703 году его опришки действовали в Фотинии и Березове, в Микуличине, где во дворе убили ненавидимого атамана Гната и слугу, информировавшего шляхту о движениях опришков.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "В 1738 году впервые в долине Прута появились опрышки Олексы Довбуша, напавшие и ограбившие богачей из Черных Ославов. В 1741 г. этот отряд вел несколькодневный бой с микуличинцами, охранявшимися на летитнянской дороге угловых купцов. С обеих сторон были жертвы, а в Микуличине сожжено несколько домов. В первые годы опришковской деятельности Довбуша в его ватаге находились и некоторые жители Микуличина, в частности братья Яворовцы, Федор Никорак и Иван Кошак. Следовательно, к шайке Довбуша присоединился его сестричек Павел Орфенюк из Ямны и Василий Баюрак из Доры. Побратимы Довбуша имели по селам таких своих единомышленников как Павел и Степан Дронивы из Ямны и мелких шляхтичей из Ослав, которые снабжали отряд продовольствием и оружием.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "В Ворохте смолякам удалось привлечь к исследованию опришков самого богатого в селе Мочерняка, в Космаче Дзвинчука. В 1745 году Довбуш решил расправиться с ними. Из Ясини, где некоторое время находился, он со своими товарищами Орфенюком и Баюраком отправился к сестре в Ямне. Тогда же Баюрак посетил своих родных в Доре. После этого они вернулись в Ворохту, убили там Мочерняка, его хозяйство сожгли. Оттуда направились в Космач, чтобы расправиться с Дзвинчуком, но последний заранее узнал о намерениях Довбуша, подготовился встретить его пулей и убил предводителя опришков. Это произошло в ночь с 23 на 24 августа 1745 года. После смерти тело Довбуша разорвали, куски на ужасах населению повесили на сваях в Микуличине и Черном Потоке.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "После смерти Довбуша на время движение опришков прекратилось. Лишь в 1749 г. Семен Баюрак из Доры вместе со своим сыном и дорянами Ильком Семеновым и Андреем Дроботяковым организовали отряд, к которому приняли одно легкое из Микуличина и два легких из Ямны и совершили нападение на корчмаря в Стопчатове. Нападение было неудачным, Семен с некоторыми собратьями попались в руки карателей. На этом главные выступления опришков против феодалов закончились.",
                    },
                    {
                        h2: "Под Австрийскими властями",
                        img: "",
                        p: "В 1781 году из 775 жителей было 763 украинца и 12 евреев, в 1900 - из 4306 жителей - 3429 украинцев, 268 поляков и 608 евреев. По данным в Микуличине в 1880 году было 75155 моргов земли, в том числе: 366 - пашня, 5089 - луга, 25 - огороды, 8418 - пастбища, 5322 - горные долины, 54279 - леса. Такая площадь не могла обеспечить потребности населения в зерновых культурах и овощах, поэтому в горах крестьяне занимались прежде всего животноводством.",
                    },
                ],
            },
            {
                title: "Развлечения",
                img: {
                    img_1280: IMAGES.BLOG.ENTERTAINMENT_1280,
                    img_768: IMAGES.BLOG.ENTERTAINMENT_768,
                    img_300: IMAGES.BLOG.ENTERTAINMENT_300,
                },
                content: [
                    {
                        h2: "Пешие прогулки по горам.",
                        img: {
                            img_1280: IMAGES.BLOG.WALKS_1280,
                            img_768: IMAGES.BLOG.WALKS_768,
                            img_300: IMAGES.BLOG.WALKS_300,
                        },
                        p: "Гора Ягодная (1 216 м). К ней от остановки автобуса ведет лесная дорога: подъём несложный, крутых участков практически не встречается, идти на вершину по грунтовой дороге около 2-3 часов (зависимо от погодных условий, состояния дороги и личного настроения путешественников). До Ягодной из центра Микуличина - 7 км. С горы открывается широкая панорама на самый высокий горный хребет Украины — Черногорский. На вершине Ягодной вы обнаружите деревянную беседку: будет где отдохнуть и вдоволь налюбоваться горными пейзажами! Захватите с собой бутерброды, термос и шоколадный батончик — чистый горный воздух и двухчасовой подъём обязательно разбудят чувство голода! Большое преимущество этого простенького маршрута в том, что его можно позволить себе и летом, и зимой: поблизости Ягодной есть полонина Лиснив, там расположена гуцульская колыба с дровяной печью и широкими лежанками, а этого вполне достаточно для комфортной и безопасной ночевки вдали от удобств поселка.", 
                    },
                    {
                        h2: "Покупки в Микуличине.",
                        img: {
                            img_1280: IMAGES.BLOG.SHOPING_1280,
                            img_768: IMAGES.BLOG.SHOPING_768,
                            img_300: IMAGES.BLOG.SHOPING_300,
                        },
                        p: `Новый торговый комплекс Hutsul Plaza (2020) расположен среди Карпатских гор, близ Буковеля, на первой линии от центральной дороги Яремче-Буковель. «Hutsul Plaza» – это 1000 м2, сочетающих современный стиль, изысканность, трендовые дизайнерские и ландшафтные решения. Для посетителей комплекса «Hutsul Plaza» гарантируем море положительных эмоций от шопинга, веселое настроение и отличное время во время организации развлекательных программ, празднований, проведения ярмарк, конкурсов, дегустаций, фестивалей.`,
                    },
                    {
                        h2: "Церковь Святой Троицы (1868 г.).",
                        img: {
                            img_1280: IMAGES.BLOG.CHURCH_1280,
                            img_768: IMAGES.BLOG.CHURCH_768,
                            img_300: IMAGES.BLOG.CHURCH_300,
                        },
                        p: "Украшением Микуличина является памятник архитектуры — церковь Святой Троицы (1868 г.) и построенная значительно раньше колокольня. Роспись иконостаса исполнил выдающийся украинский художник, поэт и драматург Корнило Устиянович (1839–1903).",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Первые письменные упоминания о местной церкви происходят с 1700 г. Старая деревянная церковь была размещена на кладбище выше поселка Фальчи. В 1760-х гг. ее разрушил сильный ураган. Строительство существующей деревянной Троицкой церкви (начавшееся в 1866 г.) завершилось в 1868 г. Церковь была построена по проекту цесарско-королевского инженера архитектора Надворнянского уездного правительства Я. Чайковецкого. Летом 1911 г. разрушительное наводнение нанесло селу немалый ущерб. Поэтому в этот и последующие годы проводили ремонт церкви: покрыли крышу жестью, а колокольню — гонтом.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "В старину кресты на куполах церкви были деревянные. Современные металлические кресты и решетки к церковным окнам были установлены в 1929 г.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "С 1927 года, когда по инициативе митрополита Андрея Шептицкого был построен Станиславской епархией в Микуличине основное здание монастыря Конгрегации Сестер Служебниц Непорочной Девы Марии, монахини осуществляли в селе христианскую опеку, бесплатно вели религиозное дошкольное воспитание детей.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "Во время Второй мировой войны из церкви нацисты забрали 4 серебряных колокола. Самый большой из них весил 5 тонн. Его звон был слышен в радиусе 12 км.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "После второй мировой войны церковь была действующей. Сегодня в церкви находится 5 колоколов, самый большой из которых весит 6 центнеров. В 2002 г. на воротах церкви построена новая колокольня. Церковь является памяткой архитектуры национального значения. Состоит в пользовании общины УГКЦ.",
                    },
                    {
                        h2: "",
                        img: "",
                        p: "В настоящее время среди жителей села исторически преобладают греко-католики. После периода преследования церкви в советское время, греко-католицизм в деревне возобновился в декабре 1989 года. Инициатором этого выступил священник села — о. Григорий Чиборак: объявил в церкви мирянам, что они вправе решить или оставаться в подчинении Московского патриархата или вернуться к вере родителей — УГКЦ. Для этого каждому из них нужно было подписаться в одном из трех списков этих конфессий. Более тысячи подписей было в списке УГКЦ и ни одной в списках других конфессий.",
                    },
                    {
                        h2: "Водопад Женецкий (Гук).",
                        img: {
                            img_1280: IMAGES.BLOG.WATERFALL_1280,
                            img_768: IMAGES.BLOG.WATERFALL_768,
                            img_300: IMAGES.BLOG.WATERFALL_300,
                        },
                        p: "Однокаскадный 15-метровый красавец уютно расположился в компании смерекового леса и каменистых Горган. Находится в заповедном урочище Женец на одноименной реке. До Гука легко доехать и даже дойти. Это один из немногих карпатских водопадов к которому ведет отличная асфальтированная дорога. И пусть она длится только 3 км, а остальные 3 км придется прогуляться классической горной грунтовкой слегка размытой дождями и разъезженной автомобилями. Но путь того стоит: Гук — высокий и утонченный: летом не пересыхает, а зимой наряжается изысканными сосульками, поэтому в любую пору года вы не пожалеете, что пришли сюда!",
                    },
                    {
                        h2: `Пивоварня “Микуличин”.`,
                        img: {
                            img_1280: IMAGES.BLOG.BREWERY_1280,
                            img_768: IMAGES.BLOG.BREWERY_768,
                            img_300: IMAGES.BLOG.BREWERY_300,
                        },
                        p: `Открытая в 2002 году пивоварня варит пиво натуральным способом, выпуская его в продажу под торговой маркой “Гуцульское”. Не стоит искать больших бетонных сооружений, привычных для глаза горожанина из промышленных городов: в Микуличине пиво варят в небольшом деревянном доме, где чудом размещается участок пивоварения и технические отделы. Оборудование для производства пива поставили из Венгрии, а смонтировали в классической гуцульской хате, которую по внешнему виду сложно выделить из таких же строений вокруг. По задумке владельца, производство натурального пива должно гармонировать с окружающим миром и культурой края. Брожение “Гуцульского” продолжается 7 дней и ещё 14 дней пиво дозревает. Тут варят Медовое и Темное, Светлое “Юбилейное” и Белое “Гуцульское”. Мед, между прочим, для Медового пива получают с собственной пасеки. На территорию пивоварни можно пройти с экскурсией, записаться на дегустацию пива и заглянуть в фирменный магазин за пенным трофеем. Найти магазин не проблема: в самом центре Микуличина находится небольшой, аккуратненький домик с фирменной вывеской — мимо не пройти и не проехать!`,
                    },
                ],
            },
        ],
        footer: [ 
            {
                title: "Адрес:",
                text_1: "улица Грушевского",
                text_2: "78590, Микуличин",
                text_3: "Ивано-Франковская область",
                text_4: "Украина",
            },
            {
                title: "Телефоны:",
                text_1: "+380343439401",
            },
            {
                title: "Социальные сети:",
            },
        ],
    },

    //социальные сети
    // socialUrl: [
    //   {url: 'https://www.facebook.com/groups/ali.ukraine', img: assets.ICONS.FACEBOOK,},
    //   {url: 'https://www.instagram.com/ali.in.ua/', img: assets.ICONS.INSTAGRAM,},
    //   {url: 'https://twitter.com/UaAliexpress', img: assets.ICONS.TWITTER,},
    //   {url: 'https://www.youtube.com/channel/UCwvoDgJjnDOYcKvZ2DQJ_aQ', img: assets.ICONS.YOUTUBE,},
    //   {url: 'https://www.tiktok.com/@ali.in.ua', img: assets.ICONS.TIKTOK,},
    //   {url: 'https://www.reddit.com/user/SWSCompany', img: assets.ICONS.REDDIT,},
    // ],
  };

export default Store;